import React from 'react';
import { Link } from 'react-router-dom';

const CpanelBreadcrumb = ({ items }) => {
  if (!items?.length) return null;

  return (
    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 cpanel-breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const key = `${item.label}-${index}`;

        return (
          <React.Fragment key={key}>
            {index > 0 ? (
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
            ) : null}
            <li
              className={`breadcrumb-item ${isLast ? 'text-dark' : 'text-muted'}`}
              aria-current={isLast ? 'page' : undefined}
            >
              {!isLast && item.to ? (
                <Link to={item.to} className="text-muted text-hover-primary">
                  {item.label}
                </Link>
              ) : (
                item.label
              )}
            </li>
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default CpanelBreadcrumb;
